import { config } from '@app/componentlib/config'

export const apiUrl = (path: string, endpoint: string, params?: any): string => {
  let searchParams = ''
  if(params !== undefined) {
    for (let param in params) {
      if (params[param] === undefined
        || params[param] === null
      ) {
        delete params[param];
      }
    }
    searchParams = new URLSearchParams(params).toString()
  }
  const portalApi = config.server.portalApi
  return `${portalApi + path}/${endpoint}${searchParams !== '' ? `?${searchParams}` : ''}`
}